$(document).ready(function(){

 
  var brandList = $('.brands-list');
  
  for(var i = 0; i <  brandList.length; i++){
    if(brandList.eq(i).html() == ""){
      var letter = brandList.eq(i).closest('.brands-letter-container').find('.brands-letter').html().trim();
      $('button[data-letter="'+letter+'"]').eq(0).addClass('disabled');
      brandList.eq(i).closest('.brands-letter-container').remove();
    }
  }

   $('button[data-letter].brand-letters-nav__letter').click(function(){
     var letter = $(this).attr('data-letter');
    $('html, body').animate({
        scrollTop: $('h2.brands-letter[data-letter="'+letter+'"').parent().offset().top - 20
    }, 300);
  }); 
});